import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { User } from "../../pages/login/login.model";
import loginService from "./loginService";

interface forgotUsernameState {
  forgotUsernameData: any;
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  message: string;
}

const initialState: forgotUsernameState = {
  forgotUsernameData: "",
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

//forgot username slice
export const forgotUsername = createAsyncThunk("auth/forgot-username", async (userData: User, thunkAPI) => {
  try {
    const response = await loginService.forgotUsernameService(userData);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const forgotUsernameSlice = createSlice({
  name: "forgotUsername",
  initialState,
  reducers: {
    resetForgotUsername: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(forgotUsername.pending, (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      })
      .addCase(forgotUsername.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.forgotUsernameData = action.payload;
      })
      .addCase(forgotUsername.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { resetForgotUsername } = forgotUsernameSlice.actions;
